import { Dictionary } from "vue-router/types/router";

export class AssetRepository {
  public static ASSET_REPOSITORY: Dictionary<AssetTheme> = {
    logo: {
      light: require("@/assets/logo.png")
    },
    mmmint: {
      light: require("@/assets/mmmint.ai.png")
    },
    wirkaufendeinethg: {
      light: require("@/assets/wkdthg-light.png"),
      dark: require("@/assets/wkdthg-dark.png")
    },
    forest: {
      light: require("@/assets/forest-unsplash.jpg")
    },
    charging: {
      light: "https://static.mmmint.ai/wirkaufendeinethg/photo-1593941707882-a5bba14938c7.jpeg"
    },
    cockpit: {
      light: require("@/assets/cockpit.svg")
    },
    cockpitOutline: {
      light: require("@/assets/cockpit_outline.svg")
    },
    cockpitExample: {
      light: require("@/assets/instructions/cockpit_blaupause.gif"),
      dark: require("@/assets/instructions/cockpit_blaupause_dark.gif")
    },
    cockpitInstruction: {
      light: require("@/assets/instructions/cockpit.jpeg")
    },
    carFrontLeft: {
      light: require("@/assets/car_front_left.svg")
    },
    carFrontRight: {
      light: require("@/assets/car_front_right.svg")
    },
    carRearLeft: {
      light: require("@/assets/car_rear_left.svg")
    },
    carRearRight: {
      light: require("@/assets/car_rear_right.svg")
    },
    containerFrontLeft: {
      light: require("@/assets/container_front_left.svg")
    },
    containerFrontRight: {
      light: require("@/assets/container_front_right.svg")
    },
    containerRearLeft: {
      light: require("@/assets/container_rear_left.svg")
    },
    containerRearRight: {
      light: require("@/assets/container_rear_right.svg")
    },
    motorbikeFrontLeft: {
      light: require("@/assets/motorbike-front-left.svg")
    },
    motorbikeFrontRight: {
      light: require("@/assets/motorbike-front-right.svg")
    },
    motorbikeRearLeft: {
      light: require("@/assets/motorbike-rear-left.svg")
    },
    motorbikeRearRight: {
      light: require("@/assets/motorbike-rear-right.svg")
    },
    damageOverviewContainerInstruction: {
      light: require("@/assets/instructions/damageOverviewContainer.png")
    },
    damageDetail: {
      light: require("@/assets/car_damage_detail.svg")
    },
    carFrontLeftOutline: {
      light: require("@/assets/car_front_left_outline.svg")
    },
    carFrontRightOutline: {
      light: require("@/assets/car_front_right_outline.svg")
    },
    carRearLeftOutline: {
      light: require("@/assets/car_rear_left_outline.svg")
    },
    carRearRightOutline: {
      light: require("@/assets/car_rear_right_outline.svg")
    },
    damageDetailOutline: {
      light: require("@/assets/car_damage_detail_outline.svg")
    },
    damageDetailExample: {
      light: require("@/assets/instructions/damage_detail_blaupause.gif"),
      dark: require("@/assets/instructions/damage_detail_blaupause_dark.gif")
    },
    damage: {
      light: require("@/assets/car_damage.svg")
    },
    damageOutline: {
      light: require("@/assets/car_damage_outline.svg")
    },
    overview: {
      light: require("@/assets/instructions/overview_blaupause.gif"),
      dark: require("@/assets/instructions/overview_blaupause_dark.gif")
    },
    registration: {
      light: require("@/assets/registration.svg")
    },
    registrationSchema: {
      light: require("@/assets/registration_form_schema.svg")
    },
    registrationBack: {
      light: require("@/assets/registration_back.svg")
    },
    registrationBackOutline: {
      light: require("@/assets/registration_back_outline.svg")
    },
    registrationExample: {
      light: require("@/assets/instructions/registration_blaupause.gif"),
      dark: require("@/assets/instructions/registration_blaupause_dark.gif")
    },
    registrationCorrectInstructions: {
      light: require("@/assets/instructions/beispielrichtig.gif")
    },
    registrationIncorrectInstructions: {
      light: require("@/assets/instructions/beispielfalsch.gif")
    },
    registrationAt: {
      light: require("@/assets/registration_at.svg")
    },
    registrationAtSchema: {
      light: require("@/assets/registration_at_schema.svg")
    },
    registrationAtBack: {
      light: require("@/assets/registration_at_back.svg")
    },
    registrationAtBackSchema: {
      light: require("@/assets/registration_at_schema_back.svg")
    },
    registrationAtExample: {
      light: require("@/assets/instructions/registration_at_blaupause.webp") // FIXME
    },
    registrationAtCorrectInstructions: {
      light: require("@/assets/instructions/registration_at_example.gif")
    },
    registrationAtIncorrectInstructions: {
      light: require("@/assets/instructions/registration_at_example_old.gif")
    },
    damageOverviewBehindInstruction: {
      light: require("@/assets/instructions/overview_behind.png")
    },
    damageOverviewFrontInstruction: {
      light: require("@/assets/instructions/overview_front.png")
    },
    damageDetailInstruction: {
      light: require("@/assets/instructions/damage_detail.png")
    },
    damageInstruction: {
      light: require("@/assets/instructions/damage.png")
    },
    damageExample: {
      light: require("@/assets/instructions/damage_blaupause.gif"),
      dark: require("@/assets/instructions/damage_blaupause_dark.gif")
    },
    emptyData: {
      light: require("@/assets/undraw/undraw_no_data_re_kwbl.svg")
    },
    loading: {
      light: require("@/assets/undraw/undraw_loading_re_5axr.svg")
    },
    towingTruck: {
      light: require("@/assets/undraw_towing_6yy4.svg")
    },
    fixingBugs: {
      light: require("@/assets/undraw/undraw_fixing_bugs.svg")
    },
    qaEngineer: {
      light: require("@/assets/undraw/undraw_qa_engineers.svg")
    },
    warning: {
      light: require("@/assets/undraw/undraw_warning.svg")
    },
    serverDown: {
      light: require("@/assets/undraw/undraw_server_down.svg")
    },
    tuev: {
      light: require("@/assets/tuev.svg")
    },
    tire: {
      light: require("@/assets/tire.png")
    },
    trunk: {
      light: require("@/assets/trunk.png")
    },
    tireInformation: {
      light: require("@/assets/tire-information.svg")
    }
  };

  public static getAsset(isDarkTheme: boolean, assetType: AssetEnum) {
    if (assetType in this.ASSET_REPOSITORY) {
      const hasDarkTheme = this.ASSET_REPOSITORY[assetType].dark
        ? this.ASSET_REPOSITORY[assetType].dark
        : this.ASSET_REPOSITORY[assetType].light;
      return isDarkTheme ? hasDarkTheme : this.ASSET_REPOSITORY[assetType].light;
    }
  }
}

export enum AssetEnum {
  logo = "logo",
  mmmint = "mmmint",
  wirkaufendeinethg = "wirkaufendeinethg",
  overview = "overview",
  cockpit = "cockpit",
  cockpitOutline = "cockpitOutline",
  cockpitExample = "cockpitExample",
  cockpitInstruction = "cockpitInstruction",
  damageDetail = "damageDetail",
  damageDetailOutline = "damageDetailOutline",
  damageDetailExample = "damageDetailExample",
  damageDetailInstruction = "damageDetailInstruction",
  damage = "damage",
  damageOutline = "damageOutline",
  damageExample = "damageExample",
  damageInstruction = "damageInstruction",
  damageOverviewContainerInstruction = "damageOverviewContainerInstruction",
  damageOverviewBehindInstruction = "damageOverviewBehindInstruction",
  damageOverviewFrontInstruction = "damageOverviewFrontInstruction",
  carFrontLeft = "carFrontLeft",
  carFrontRight = "carFrontRight",
  carRearLeft = "carRearLeft",
  carRearRight = "carRearRight",
  carFrontLeftOutline = "carFrontLeftOutline",
  carFrontRightOutline = "carFrontRightOutline",
  carRearLeftOutline = "carRearLeftOutline",
  carRearRightOutline = "carRearRightOutline",

  containerFrontLeft = "containerFrontLeft",
  containerFrontRight = "containerFrontRight",
  containerRearLeft = "containerRearLeft",
  containerRearRight = "containerRearRight",

  motorbikeFrontLeft = "motorbikeFrontLeft",
  motorbikeFrontRight = "motorbikeFrontRight",
  motorbikeRearLeft = "motorbikeRearLeft",
  motorbikeRearRight = "motorbikeRearRight",

  registration = "registration",
  registrationSchema = "registrationSchema",
  registrationBack = "registrationBack",
  registrationBackOutline = "registrationBackOutline",
  registrationExample = "registrationExample",
  registrationCorrectInstructions = "registrationCorrectInstructions",
  registrationIncorrectInstructions = "registrationIncorrectInstructions",
  registrationIncorrectInstructionsPlaceholder = "registrationIncorrectInstructionsPlaceholder",
  registrationCorrectInstructionsPlaceholder = "registrationCorrectInstructionsPlaceholder",

  registrationAt = "registrationAt",
  registrationAtSchema = "registrationAtSchema",
  registrationAtBack = "registrationAtBack",
  registrationAtBackSchema = "registrationAtBackSchema",
  registrationAtExample = "registrationAtExample",
  registrationAtCorrectInstructions = "registrationAtCorrectInstructions",
  registrationAtIncorrectInstructions = "registrationAtIncorrectInstructions",
  registrationAtIncorrectInstructionsPlaceholder = "registrationAtIncorrectInstructionsPlaceholder",
  registrationAtCorrectInstructionsPlaceholder = "registrationAtCorrectInstructionsPlaceholder",

  tuev = "tuev",
  trunk = "trunk",
  tire = "tire",
  tireInformation = "tireInformation",

  emptyData = "emptyData",
  loading = "loading",
  forest = "forest",
  charging = "charging",
  towingTruck = "towingTruck",
  fixingBugs = "fixingBugs",
  qaEngineer = "qaEngineer",
  warning = "warning",
  serverDown = "serverDown"
}

interface AssetTheme {
  light: any;
  dark?: any;
}
